import { Card, Col, Row } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../network/authContext";
import { hasAnyPermission, modulePermissions } from "../../../network/adminPermissions";

import AddLeagueModal from "./subviews/leagues/AddLeagueModal";
import AddRefereeModal from "./subviews/referees/AddRefereeModal";
import AssignRefereeModal from "./subviews/referees/AssignRefereeModal";
import ManualRegistrationModal from "./subviews/registrations/ManualRegistrationModal";
import AddStadiumModal from "./subviews/stadium/AddStadiumModal";
import AddUserModal from "./subviews/user/AddUserModal";

export default function AdminPanel() {
  const { user } = useAuth();
  const canAccess = module => hasAnyPermission(user, modulePermissions(module));
  const [isAddUserModalVisible, setAddUserModalVisible] = useState(false);
  const [isAddRefereeModalVisible, setAddRefereeModalVisible] = useState(false);
  const [isAddLeagueModalVisible, setAddLeagueModalVisible] = useState(false);
  const [isAddRegistrationModalVisible, setAddRegistrationModalVisible] =
    useState(false);
  const [isAddAssignRefereeModalVisible, setAddAssignRefereeModalVisible] =
    useState(false);
  const [isAddStadiumModalVisible, setAddStadiumModalVisible] = useState(false);

  // USER Registration
  const showAddUserModal = () => {
    setAddUserModalVisible(true);
  };

  const handleAddUserModalCancel = () => {
    setAddUserModalVisible(false);
  };

  const handleAddUserModalCreate = () => {
    // Handle user creation logic here
    setAddUserModalVisible(false);
  };

  // Registration
  const showAddRegistrationModal = () => {
    setAddRegistrationModalVisible(true);
  };

  const handleAddRegistrationModalCancel = () => {
    setAddRegistrationModalVisible(false);
  };

  const handleAddRegistrationModalCreate = () => {
    // Handle user creation logic here
    setAddRegistrationModalVisible(false);
  };

  // Referee
  const showAddRefereeModal = () => {
    setAddRefereeModalVisible(true);
  };

  const handleAddRefereeModalCancel = () => {
    setAddRefereeModalVisible(false);
  };

  const handleAddRefereeModalCreate = () => {
    // Handle user creation logic here
    setAddRefereeModalVisible(false);
  };

  // Assign Referee
  const showAddAssignRefereeModal = () => {
    setAddAssignRefereeModalVisible(true);
  };

  const handleAddAssignRefereeModalCancel = () => {
    setAddAssignRefereeModalVisible(false);
  };

  // League
  const showAddLeagueModal = () => {
    setAddLeagueModalVisible(true);
  };

  const handleAddLeagueModalCancel = () => {
    setAddLeagueModalVisible(false);
  };

  const handleAddLeagueModalCreate = () => {
    // Handle user creation logic here
    setAddLeagueModalVisible(false);
  };

  // Stadium
  const showAddStadiumModal = () => {
    setAddStadiumModalVisible(true);
  };

  const handleAddStadiumModalCancel = () => {
    setAddStadiumModalVisible(false);
  };

  return (
    <div>
      <Row gutter={[32, 32]} className="hp-mb-32">
        {canAccess('users') && <Col xl={8} md={12} xs={24}>
          <Card
            className="hp-knowledge-basic-card"
            style={{ minHeight: "230px" }}
          >
            <h4>Admin Benutzer</h4>
            <p className="hp-mb-4">
              <Link to="/admin/user">Benutzer Übersicht</Link>
            </p>
            <p className="hp-mb-4">
              <a href="#" onClick={showAddUserModal}>
                Neuen Benutzer hinzufügen
              </a>
            </p>
          </Card>
        </Col>}

        {canAccess('teams') && <Col xl={8} md={12} xs={24}>
          <Card
            className="hp-knowledge-basic-card"
            style={{ minHeight: "230px" }}
          >
            <h4>Mannschaften</h4>
            <p className="hp-mb-4">
              <Link to="/admin/team">Team Übersicht</Link>
            </p>
            <p className="hp-mb-4">
              <Link to="/admin/team/users">Team Login Übersicht</Link>
            </p>
            <p className="hp-mb-4">
              <Link to="/admin/players">Spieler Übersicht</Link>
            </p>
            <p className="hp-mb-4">
              <Link to="/admin/team/pending">Spieler Berechtigungen</Link>
            </p>

            <p className="hp-mb-4">
              <Link to="/admin/transfers">Transfer Übersicht</Link>
            </p>

            <p className="hp-mb-4">
              <Link to="/admin/transfer_settings">Transfer Einstellungen</Link>
            </p>
          </Card>
        </Col>}

        {canAccess('referees') && <Col xl={8} md={12} xs={24}>
          <Card
            className="hp-knowledge-basic-card"
            style={{ minHeight: "230px" }}
          >
            <h4>Schiedsrichter</h4>
            <p className="hp-mb-4">
              <Link to="/admin/referee">Schiedsrichter Übersicht</Link>
            </p>
            <p className="hp-mb-4">
              <a href="#" onClick={showAddRefereeModal}>
                Neuen Schiedsrichter hinzufügen
              </a>
            </p>
          </Card>
        </Col>}

        {canAccess('discipline') && <Col xl={8} md={12} xs={24}>
          <Card
            className="hp-knowledge-basic-card"
            style={{ minHeight: "230px" }}
          >
            <h4>Strafsenat</h4>
            <p className="hp-mb-4">
              <Link to="/admin/strafsenat">Strafsenat Übersicht</Link>
            </p>
          </Card>
        </Col>}

        {canAccess('competitions') && <Col xl={8} md={12} xs={24}>
          <Card
            className="hp-knowledge-basic-card"
            style={{ minHeight: "230px" }}
          >
            <h4>Ligen</h4>
            <p className="hp-mb-4">
              <a href="#" onClick={showAddLeagueModal}>
                Neue Liga hinzufügen
              </a>
            </p>
            <p className="hp-mb-4">
              <Link to="/admin/league">Ligen und Spielplan</Link>
            </p>
            <p className="hp-mb-4">
              <Link to="/admin/stadiums">Stadion Übersicht</Link>
            </p>
            <p className="hp-mb-4">
              <a href="#" onClick={showAddStadiumModal}>
                Neues Stadion hinzufügen
              </a>
            </p>
            <p className="hp-mb-4">
              <Link to="/admin/postpone">Spielverlegungs Anfragen</Link>
            </p>
          </Card>
        </Col>}

        {canAccess('orders') && <Col xl={8} md={12} xs={24}>
          <Card
            className="hp-knowledge-basic-card"
            style={{ minHeight: "230px" }}
          >
            <h4>Neue Anmeldungen</h4>
            <p className="hp-mb-4">
              <Link to="/admin/registrations">Registrierungs Übersicht</Link>
            </p>
            <p className="hp-mb-4">
              <a href="#" onClick={showAddRegistrationModal}>
                Manuelle Registrierung starten
              </a>
            </p>
          </Card>
        </Col>}

        {canAccess('communications') && <Col xl={8} md={12} xs={24}>
          <Card
            className="hp-knowledge-basic-card"
            style={{ minHeight: "230px" }}
          >
            <h4>Nachrichten</h4>
            <p className="hp-mb-4">
              <Link to="/admin/chat">Admin Posteingang</Link>
            </p>
          </Card>
        </Col>}

        {canAccess('finances') && <Col xl={8} md={12} xs={24}>
          <Card
            className="hp-knowledge-basic-card"
            style={{ minHeight: "230px" }}
          >
            <h4>Finanzen</h4>
            <p className="hp-mb-4"><Link to="/admin/fees">Gebühren &amp; Beträge</Link></p>
            <p className="hp-mb-4">
              <Link to="/admin/rechnungen">Rechnungen Übersicht</Link>
            </p>
            <p className="hp-mb-4">
              <Link to="/admin/rechnung_erstellung">Neue Rechnung erstellen</Link>
            </p>
          </Card>
        </Col>}

        {canAccess('communications') && <Col xl={8} md={12} xs={24}>
          <Card className="hp-knowledge-basic-card" style={{ minHeight: "230px" }}>
            <h4>E-Mail Notifier</h4>
            <p>Automatische E-Mails, Variablen, HTML und Signaturen verwalten.</p>
            <p className="hp-mb-4"><Link to="/admin/email-templates">E-Mail-Vorlagen bearbeiten</Link></p>
          </Card>
        </Col>}

        {canAccess('homepage') && <Col xl={8} md={12} xs={24}>
          <Card
            className="hp-knowledge-basic-card"
            style={{ minHeight: "230px" }}
          >
            <h4>Homepage</h4>
            <p className="hp-mb-4"><Link to="/admin/homepage-analytics">Homepage Analytics</Link></p>
            <p className="hp-mb-4">
              <Link to="/admin/news">News Übersicht</Link>
            </p>
            <p className="hp-mb-4">
              <Link to="/admin/news_strafsenat">Strafsenat News Übersicht</Link>
            </p>
            <p className="hp-mb-4">
              <Link to="/admin/legal">Regeln und Ordnungen verwalten</Link>
            </p>
            <p className="hp-mb-4">
              <Link to="/admin/homepage-content">Homepage-Inhalte verwalten</Link>
            </p>
            <p className="hp-mb-4">
              <Link to="/admin/sponsors">Sponsoren und Partner verwalten</Link>
            </p>
            <p className="hp-mb-4">
              <Link to="/admin/push-notifications">
                Push Notification Broadcast Manager
              </Link>
            </p>
          </Card>
        </Col>}

        {canAccess('events') && <Col xl={8} md={12} xs={24}>
          <Card
            className="hp-knowledge-basic-card"
            style={{ minHeight: "230px" }}
          >
            <h4>Events und Gästeliste</h4>
            <p className="hp-mb-4">
              <Link to="/admin/people-events">Events Übersicht</Link>
            </p>
            <p className="hp-mb-4">
              <Link to="/admin/people-events?create=1">Neues Event erstellen</Link>
            </p>
            <p className="hp-mb-4">
              <Link to="/admin/people-events">Gästelisten verwalten</Link>
            </p>
          </Card>
        </Col>}
      </Row>

      <AddUserModal
        visible={isAddUserModalVisible}
        onCancel={handleAddUserModalCancel}
        onCreate={handleAddUserModalCreate}
      />
      <AddRefereeModal
        visible={isAddRefereeModalVisible}
        onCancel={handleAddRefereeModalCancel}
        onCreate={handleAddRefereeModalCreate}
      />
      <AddLeagueModal
        visible={isAddLeagueModalVisible}
        onCancel={handleAddLeagueModalCancel}
      />

      <ManualRegistrationModal
        visible={isAddRegistrationModalVisible}
        onCancel={handleAddRegistrationModalCancel}
      />

      <AssignRefereeModal
        visible={isAddAssignRefereeModalVisible}
        onCancel={handleAddAssignRefereeModalCancel}
      />
      <AddStadiumModal
        visible={isAddStadiumModalVisible}
        onCancel={handleAddStadiumModalCancel}
      />
    </div>
  );
}
